import EraType from "@/roc/era/EraType";
export var WorkshopProductionGroup;
(function (WorkshopProductionGroup) {
    WorkshopProductionGroup["Artisan"] = "Artisan";
    WorkshopProductionGroup["StoneMason"] = "StoneMason";
    WorkshopProductionGroup["Tailor"] = "Tailor";
    WorkshopProductionGroup["Scribe"] = "Scribe";
    WorkshopProductionGroup["Carpenter"] = "Carpenter";
    WorkshopProductionGroup["SpiceMerchant"] = "SpiceMerchant";
    WorkshopProductionGroup["Jeweler"] = "Jeweler";
    WorkshopProductionGroup["Alchemist"] = "Alchemist";
    WorkshopProductionGroup["Glassblower"] = "Glassblower";
})(WorkshopProductionGroup || (WorkshopProductionGroup = {}));
// Gotcha: These icons MUST have names that uses underscore instead of space.
const WorkshopOutput = {
    Artisan: {
        bronzeAge: "Bronze_Bracelet",
        minoanEra: "Iron_Pendant",
        classicGreece: "Silver_Ring",
        earlyRome: "Gold_Laurel",
        romanEmpire: "Goblet",
    },
    StoneMason: {
        bronzeAge: "Alabaster_Idol",
        minoanEra: "Marble_Bust",
        classicGreece: "Column",
        earlyRome: "Stone_Tablet",
        romanEmpire: "Mosaic",
    },
    Tailor: {
        bronzeAge: "Wool",
        minoanEra: "Linen_Shirt",
        classicGreece: "Toga",
        earlyRome: "Tunic",
        romanEmpire: "Cape",
    },
    Carpenter: {
        byzantineEra: "Planks",
        ageOfTheFranks: "Cartwheel",
        feudalAge: "Barrel",
        iberianEra: "Door",
        kingdomOfSicily: "Wardrobe",
        highMiddleAges: "Secretary_Desk",
    },
    Scribe: {
        byzantineEra: "Parchment",
        ageOfTheFranks: "Ink",
        feudalAge: "Manuscript",
        iberianEra: "Wax_Seal",
        kingdomOfSicily: "Tome",
        highMiddleAges: "Grimoire",
    },
    SpiceMerchant: {
        byzantineEra: "Pepper",
        ageOfTheFranks: "Salt",
        feudalAge: "Herbs",
        iberianEra: "Saffron",
        kingdomOfSicily: "Chili",
        highMiddleAges: "Cinnamon",
    },
    Jeweler: {
        earlyGothicEra: "Fine_Jewelry",
        lateGothicEra: "Embellishments",
    },
    Glassblower: {
        earlyGothicEra: "Lead_Glass",
        lateGothicEra: "Stained_Glass",
    },
    Alchemist: {
        earlyGothicEra: "Ointment",
        lateGothicEra: "Elixirs",
    }
};
export function getIcon(group) {
    return function (era) {
        let icon = WorkshopOutput[group][era];
        if (!icon) {
            const keys = Object.keys(WorkshopOutput[group]);
            icon = WorkshopOutput[group][keys[keys.length - 1]];
        }
        return icon;
    };
}
export function getGoodsList(group) {
    return WorkshopOutput[group];
}
export function getCurrentEraGoods(playerEra) {
    const result = [];
    for (const i in WorkshopOutput) {
        const eraPerGood = WorkshopOutput[i];
        if (eraPerGood[playerEra] === undefined) {
            continue;
        }
        result.push(eraPerGood[playerEra]);
    }
    return result;
}
export function getPreviousEraGoods(playerEra) {
    if (playerEra === EraType.bronzeAge || playerEra === EraType.stoneAge) {
        return [];
    }
    const keys = Object.keys(EraType);
    const eraIndex = keys.indexOf(playerEra);
    return getCurrentEraGoods(keys[eraIndex - 1]);
}
export default WorkshopOutput;
